// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import React, { ReactElement } from 'react';

import './Header.scss';

interface HeadersProps {
    children: ReactElement[] | ReactElement;
    className?: string;
}

const Header = ({ children, className }: HeadersProps): ReactElement => {
    const element = React.Children.toArray(children);

    const ChildBySlot = (element as ReactElement[]).reduce((acc, element) => {
        const currentSlot = acc[element.props.name] ? acc[element.props.name] : [];
        return element ? { ...acc, [element.props.name]: [...currentSlot, element] } : acc;
    }, {} as Record<string, ReactElement[]>);

    return (
        <div className={classList('th-list-header', className)}>
            <div className="th-list-header__top">
                {ChildBySlot['MANAGE']}
                {ChildBySlot['NAVIGATION']}
            </div>
            {ChildBySlot['CONTENT']}
        </div>
    );
};

Header.displayName = 'Header';

export default Header;
